export const TICKET_OPENED = "opened";
export const TICKET_ASSIGNED = "assigned";
export const TICKET_WORK_STARTED = "work_started";
export const TICKET_WORK_COMPLETED = "work_completed";
export const TICKET_RESOLVED = "resolved";
export const TICKET_CLOSED = "verified_and_closed";
export const TICKET_REJECTED_BY_RECEPTIONIST = "rejected";
export const TICKET_REJECTED_BY_MANAGER = "rejected_by_mgr";
export const TICKET_REOPENED = "re_opened";

// MY CONDITIONS
// export const TICKET_REASSIGN =
//   !TICKET_CLOSED || !TICKET_REOPENED || !TICKET_OPENED;
